import RenderVimeoVideo from './RenderVimeoVideo';

export default RenderVimeoVideo;